module.exports = __webpack_public_path__ + "static/media/intro.0a13a81e.jpg";